// extracted by mini-css-extract-plugin
export default {"save-indicator":"styles__save-indicator--AGxaI","is-saved":"styles__is-saved--BywTe","disabled":"styles__disabled--Cp4Pe"};